import {throwError as observableThrowError,  Observable ,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NotificationService } from '../core/notification.service';
import { L10nTranslationService } from 'angular-l10n';
import { AuthService } from 'core/auth.service';
import { catchError, switchMap, finalize, filter, take } from 'rxjs/operators';
import { from } from 'rxjs';

@Injectable()
export class SamplicityHttpClient implements HttpInterceptor {
  private readonly idTokenKey: string = 'samplicity-id-token';
  private isRefreshingToken = false;
  private tokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string| null>(null);

  constructor(
    public locale: L10nTranslationService,
    private notification: NotificationService,
    private router: Router,
    private authService: AuthService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (localStorage.getItem(this.idTokenKey)) {
      const clonedRequest = this.setRequestHeaders(req, localStorage.getItem(this.idTokenKey));

      return next.handle(clonedRequest).pipe(
        catchError((err: any) => {
          if (err instanceof HttpErrorResponse) {
            // There is a probblem with nswag and new HttpClient
            // nswag is trying to handle HttpResponse's "body" property when
            // in reality it's HttpErrorResponse's "error" property
            if (err.error) {
              err['body'] = err.error;
            }
            switch (err.status) {
              case 400:
                return observableThrowError(() => err);
              case 401:
                return this.handle401Error(req, next, err);
              case 403:
                return this.handleUnauthorizedRequest(err, err.status);
              default:
                this.notification.handleError(err);
                return observableThrowError(() => err);
            }
          }
          return observableThrowError(() => err);
        })
      );
    }
  }
  
  private handle401Error(req: HttpRequest<any>, next: HttpHandler, err: HttpErrorResponse): Observable<HttpEvent<any>> {
    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;
      this.tokenSubject.next(null);
      return from(this.authService.acquireToken()).pipe(
        switchMap((newToken) => {
          localStorage.setItem(this.idTokenKey, newToken.accessToken as string);
          this.tokenSubject.next(newToken.accessToken as string);
          console.log('Injecting refreshed token');
          return next.handle(this.setRequestHeaders(req, newToken.accessToken as string));
        }),
        catchError(error => {
          return this.handleUnauthorizedRequest(error, error.status);
        }),
        finalize(() => {
          this.isRefreshingToken = false;
        })
      );      
    } 
    else {
      return this.tokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(token => next.handle(this.setRequestHeaders(req, token!)))
      );
    }
  }
  
  private setRequestHeaders(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return req.clone({
      headers: req.headers
        .set('SAMPLICITY-CULTURE', this.locale.getLocale().language)
        .set('Authorization', token)
      });
  }

  private handleUnauthorizedRequest(error: HttpErrorResponse, errorCode: number = null) {
    const errorPageRoute = '/error';
    if (errorCode) {
      this.router.navigate([errorPageRoute], { queryParams: { code: errorCode }});
    } else {
      this.router.navigate([errorPageRoute]);
    }
    return observableThrowError(error);
  }
}

